import { render, staticRenderFns } from "./DefectImageViewer.vue?vue&type=template&id=32e8d6d0&"
import script from "./DefectImageViewer.vue?vue&type=script&lang=js&"
export * from "./DefectImageViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports